module.exports = __webpack_public_path__ + "img/quiz-best.3e81234b.svg";